import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './ghs-view-header.css.lit';

export type ViewHeaderVariant = 'default' | 'alternative';

/**
 * Pager Component
 * @element ghs-view-header
 */
@customElement('ghs-view-header')
export class GhsViewHeader extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Variant view header
   * @param variant
   */
  @property({ type: String, attribute: 'variant' })
  variant: ViewHeaderVariant = 'default';

  render(): TemplateResult {
    const classes = {
      'view-header': true,
      [`view-header--${this.variant}`]: true,
    };

    return this.variant === 'alternative'
      ? html`
          <div class="${classMap(classes)}">
            <slot name="left-side"></slot>
            <div class="separator"></div>
            <slot name="right-side"></slot>
          </div>
        `
      : html`
          <div class="${classMap(classes)}">
            <slot></slot>
          </div>
        `;
  }
}
